module.exports = {
	attributes: state => state.attributes,
	permissions: state => state.permissions,
	roles: state => state.roles,
	users: state => state.users,
	usersLastPage: state => state.users_last_page,
	usersPage: state => state.users_page,

	selectedAttribute: state => id =>
		state.attributes.find(item => item.id == +id),
	selectedPart: (state, getters, rootState) => id =>
		rootState["quote-builder"].parts.find(item => item.id == +id),
	selectedRole: state => slug => state.roles.find(item => item.slug == slug),
	selectedUser: state => id => state.users.find(item => item.id == +id),

	permissionGroups: ({ permissionGroups }) =>
		(permissionGroups || []).map(({ id, name, description }) => {
			if (description) {
				name = `${name} - ${description}`;
			}

			return {
				id,
				name
			};
		})
};
